function initializeBestSellerSlider() {
  var bestSellerSlider = document.querySelectorAll('.best-seller__grid .swiper-container');
  if (!bestSellerSlider[0]) return;

  bestSellerSlider.forEach(function (slider) {
    // cari tombol di dalam section best-seller terdekat (header)
    var sectionRoot = slider.closest('.best-seller');
    var prevButton = sectionRoot.querySelector('.swiper-button-prev');
    var nextButton = sectionRoot.querySelector('.swiper-button-next');

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      autoHeight: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });
  });
}
document.addEventListener('DOMContentLoaded', initializeBestSellerSlider);